import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import Cookie from 'js-cookie'
import messages from '@/lang'

Vue.use(VueI18n)

const langKey = 'zh-cn'

const i18n = new VueI18n({
  locale: langKey,
  messages
})

export default i18n
